import React, { useState, useEffect, useRef } from "react";//, useEffect
import {
  Typography
} from "@mui/material";

import {
  useQuery,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useParams } from 'react-router-dom';
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import swal from "sweetalert";
import { useTranslation } from "react-i18next";
import * as api from '../../../actions/api';
import DispenserFormData from './ReceiveItems.js';
import Constants from "../../../services/Constants";





import { format } from 'date-fns';
const AddReceive = (props) => {

  //get DispensingLanguage
const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
const lan = localStorage.getItem('LangCode');
const menukey = "receive";
const FacilityId=localStorage.getItem('FacilityId');
  
const [selectedDate, setSelectedDate] = useState(
  //new Date()
  format(new Date(), 'yyyy-MM-dd')
);
const [generatedInvoiceNo, setGeneratedInvoiceNo] = useState(
  ''
); 
  const [formData, setFormData] = useState({
      TransactionDate: selectedDate,
      SupplierInvDate: selectedDate,
      SupplierInvNo: "",
      TransactionNo: generatedInvoiceNo, 
      "FacilityId":FacilityId,
      TransactionTypeId:1,
      ReceiveFrom:"",
      OrderNo:"",
      PreparedBy:"",
      DeliveredBy: "",
      ItemGroupId:props.match.params.id, //Get the url send id
  });

  const [ManyTableData, setManyTableData] = useState( []); 
  const [updatedDetailGridData, setUpdatedDetailGridData] = useState([]);

   
  
const handleRDateChange = (date, field) => {
  
  let newDate;
  if(date==null){
   newDate=date;
  }else{
    newDate = format(new Date(date), 'yyyy-MM-dd');
  }
  setFormData({ ...formData, [field]: newDate });
  setErrorObject({ ...errorObject, [field]: null });
};

 const handleDateChange = (date) => {
  setSelectedDate(date);
}; 
 

  const [errorObject, setErrorObject] = useState({});

  const saveInFlightRef = useRef(false);
   
  const { id } = useParams();
  const queryClient = useQueryClient();

  let params={"menukey": "receive", "FacilityId":FacilityId, "TransactionTypeId":1, TransactionDate: ''};
  const {  data:invoiceNo, refetch } = useQuery([params], api.getInvoiceNo, 
    {onSuccess: (data) => {
      
      setGeneratedInvoiceNo(data);
      let fdata = { ...formData }; 
      fdata["TransactionNo"] = data; 
      setFormData(fdata); 

    },
    refetchOnWindowFocus: false,
    refetchOnmount: false,
    refetchOnReconnect: false,
    retry: false,
    staleTime: 0,//1000 * 60 * 60 * 24,
  }
    );
  
 

  const { isLoading: isSaveMutating, mutate } = useMutation(api.saveReceiveInv, {
    onSuccess: (data) => { 
      if (data.status == 200) {

      props.openNoticeModal({
        isOpen: true,
        msg: data.message,
        msgtype: data.success,
      });

     
      let route = `/${menukey}/edit/${data.TransactionId}`;
      props.history.push(route);  
      
      
      }else{
        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      }
    }
  })  

  const runSaveReceive = (payload) => {
    if (saveInFlightRef.current) return;
    saveInFlightRef.current = true;
    mutate(payload, {
      onSettled: () => {
        saveInFlightRef.current = false;
      },
    });
  };

  const handleAdd = (NonOrderProductData) => {
  
      setManyTableData(NonOrderProductData);
      setUpdatedDetailGridData(NonOrderProductData);
      

  };
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log('formData: ', e.target);

      let data = { ...formData };
      
      data[name] = value; 
      setFormData(data); 
    setErrorObject({ ...errorObject, [name]: null });
  };

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };

  const handleReset = () => {
    setFormData({
      TransactionDate: selectedDate,
      SupplierInvDate: selectedDate,
      SupplierInvNo: "",
      TransactionNo:generatedInvoiceNo, 
      FacilityId:FacilityId,
      TransactionTypeId:1, 
      ReceiveFrom:"",
      OrderNo:"",
      PreparedBy:"",
      DeliveredBy: "",
      ItemGroupId:props.match.params.id, //Get the url send id
    });
    setManyTableData([]);  
  };

  const validateForm = (formData) => {
    let validateFields = ["TransactionDate", "TransactionNo","SupplierInvNo","PreparedBy", "ReceiveFrom"]
    let errorData = {}
    let isValid = true
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] = DispensingLanguage[lan][menukey]['field is Required !']
        isValid = false
      }
    })
    setErrorObject(errorData);
    return isValid
  }

  const handleSubmit = async (e) => {
    console.log("from submit ", 
    
    );
    if (saveInFlightRef.current || isSaveMutating) return;
    if (validateForm(formData)) {
      let fDtat={...formData,'ManyJsonSave':ManyTableData,"menukey":"receive"};
      runSaveReceive(fDtat);
      
    }
  };
  const deleteReceiveInv=(data)=>{
    
    let newarray = ManyTableData.filter(element => element !== data); 
    setManyTableData(newarray);
     
    

  }

  const setUpdatedDetailsGridDataHandler = (rows) => { 
    if (saveInFlightRef.current || isSaveMutating) return;
    if (validateForm(formData)) {
      let fDtat={...formData,'ManyJsonSave':rows,"menukey":"receive"}; 
      runSaveReceive(fDtat); 
      }

    setManyTableData(rows); 
  };


  
  useEffect(() => { 
    
     
      
    
  }, []); 




  return (
    <> 
      <DispenserFormData 
      errorObject={errorObject} 
      addProductForm={true} 
      formData={formData} 
      handleChange={handleChange} 
      handleCheck={handleCheck} 
      handleReset={handleReset} 
      handleSubmit={handleSubmit} 
      ManyTableData={updatedDetailGridData}   
      handleRDateChange={handleRDateChange} 
      selectedDate={selectedDate} 
      deleteReceiveInv={deleteReceiveInv}
      setUpdatedDetailsGridDataHandler={setUpdatedDetailsGridDataHandler}
      bStockUpdate={props.permissionType}
      handleAdd={handleAdd} 
      generatedInvoiceNo={generatedInvoiceNo}
      {...props}
      isSubmitting={isSaveMutating}
      />
      
      
    </>

    
  );
};

export default AddReceive;